<template>
  <div class="login-page">
    <LoginHeader />

    <!-- 登录成功提示 -->
    <div v-show="showSuccessMessage" class="success-message">
      <div class="success-content">登录成功！</div>
    </div>

    <main class="flex-grow flex items-center justify-center py-16">
      <div class="container">
        <div class="flex flex-col md:flex-row items-center justify-center gap-12">
          <div class="hidden md:block md:w-1/2 fade-in-up" style="animation-delay: 0.2s;">
            <div class="mx-auto" style="width: 80%">
                <img
                src="../assets/images/login.png"
                alt="吉林省软件行业协会"
                class="h-auto rounded-xl shadow-lg"
                style="width: 100%; height: auto;"
              >
              <div class="mt-8 text-center">
                <h3 class="text-2xl font-bold text-gray-800">吉林省软件行业协会</h3>
                <!-- <p class="text-gray-500 mt-2">Information System Platform</p> -->
              </div>
            </div>
          </div>

          <div class="w-full max-w-md fade-in-up" style="animation-delay: 0.4s;">
            <div class="login-card p-8">
              <div class="text-center mb-8">
                <h2 class="text-2xl font-bold text-gray-800">用户登录</h2>
                <p class="text-gray-500 mt-1">USER LOGIN</p>
              </div>

              <form @submit.prevent="handleLogin">
                <div class="input-container">
                  <i class="fa fa-user input-icon"></i>
                  <input
                    type="text"
                    id="username"
                    class="form-input"
                    placeholder="请输入账号"
                    maxlength="20"
                    v-model="username"
                    @blur="checkUserRole"
                  >
                  <div v-if="errors.username" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.username }}
                  </div>
                  <div v-if="checkingRole" class="error-message text-blue-600">
                    <i class="fa fa-spinner fa-spin mr-1"></i>检查用户类型中...
                  </div>
                </div>

                <div class="input-container">
                  <i class="fa fa-lock input-icon"></i>
                  <input
                    type="password"
                    id="password"
                    class="form-input"
                    placeholder="请输入密码"
                    maxlength="20"
                    v-model="password"
                  >
                  <div v-if="errors.password" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.password }}
                  </div>
                </div>

                <div v-if="isEnterpriseUser" class="input-container">
                  <i class="fa fa-phone input-icon"></i>
                  <input
                    type="tel"
                    id="phone"
                    class="form-input"
                    placeholder="待获取手机号"
                    maxlength="11"
                    v-model="phone"
                    readonly
                    disabled
                  >
                  <div v-if="errors.phone" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.phone }}
                  </div>
                </div>

                <div v-if="isEnterpriseUser" class="input-container">
                  <i class="fa fa-shield input-icon"></i>
                  <div class="captcha-container">
                    <input
                      type="text"
                      id="code"
                      class="form-input"
                      placeholder="请输入短信验证码"
                      maxlength="6"
                      v-model="code"
                    >
                    <button
                      type="button"
                      class="btn-sms h-12 px-4 bg-primary text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      @click="sendSmsCode"
                      :disabled="isSending"
                    >{{ isSending ? `${countdown}秒后重发` : '发送验证码' }}</button>
                  </div>
                  <div v-if="errors.code" class="error-message">
                    <i class="fa fa-exclamation-circle mr-1"></i>{{ errors.code }}
                  </div>
                </div>

                <div class="flex justify-between items-center mb-6">
                  <button
                    type="button"
                    class="text-blue-600 hover:text-blue-800 transition-colors"
                    @click="showForgotPasswordModal = true"
                  >忘记密码？</button>
                  <router-link to="/register" class="text-blue-600 hover:text-blue-800 transition-colors">
                    注册
                  </router-link>
                </div>

                <button type="submit" class="btn-primary">登录</button>
              </form>
            </div>

<!--            <div class="mt-6 text-center">-->
<!--              <p class="text-gray-600">还不是会员？</p>-->
<!--              <button-->
<!--                class="mt-2 text-blue-600 hover:text-blue-800 font-medium transition-colors"-->
<!--                @click="handleJoinAssociation"-->
<!--              >-->
<!--                申请入会 <i class="fa fa-arrow-right ml-1"></i>-->
<!--              </button>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </main>
    <AppFooter />

    <div
      v-if="showForgotPasswordModal"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      @click.self="showForgotPasswordModal = false"
    >
      <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-xl border border-gray-200">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-bold text-gray-800">忘记密码</h3>
          <button
            class="text-gray-500 hover:text-gray-800"
            @click="showForgotPasswordModal = false"
          >
            <i class="fa fa-times text-lg"></i>
          </button>
        </div>
        <p class="text-gray-600 mb-6">请联系协会重置登录密码</p>
        <p class="text-gray-600">
          <i class="fa fa-phone mr-2"></i>电话：0431-85189338
        </p>
      </div>
    </div>

    <!-- 通知组件 -->
    <div
      v-show="notification.show"
      class="notification"
      :class="notification.type"
    >
      {{ notification.message }}
    </div>
  </div>
</template>

<script>
import LoginHeader from '../components/LoginHeader.vue'
import AppFooter from '../components/Footer.vue'
import { api } from '../api/index.js'
import Cookies from 'js-cookie'
import { CURRENT_CONFIG } from '@/api/config';
export default {
  name: 'LoginPage',
  components: {
    LoginHeader,
    AppFooter
  },
  data() {
    return {
      username: '',
      password: '',
      phone: '',
      originalPhone: '',
      code: '',
      uuid: '',
      isSending: false,
      countdown: 60,
      loading: false,
      checkingRole: false,
      isEnterpriseUser: true,
      errors: {},
      showForgotPasswordModal: false,
      showSuccessMessage: false,
      notification: {
        show: false,
        message: '',
        type: 'info'
      },
      TokenKey: 'Admin-Token'
    }
  },
  methods: {
    validateForm() {
      this.errors = {}
      let isValid = true

      if (!this.username.trim()) {
        this.errors.username = '请填写用户账号'
        isValid = false
      }

      if (!this.password) {
        this.errors.password = '请填写登录密码'
        isValid = false
      }

      if (this.isEnterpriseUser) {
        if (!this.code.trim()) {
          this.errors.code = '请填写短信验证码'
          isValid = false
        } else if (this.code.length !== 6) {
          this.errors.code = '短信验证码为6位数字'
          isValid = false
        }
      }

      return isValid
    },
    maskPhone(phone) {
      if (!phone || phone.length !== 11) return phone
      return phone.substring(0, 3) + '****' + phone.substring(7)
    },
    async validateCredentials() {
      try {
        const data = await api.validateCredentials(this.username, this.password)
        return data
      } catch (error) {
        console.error('校验账号密码失败:', error)
        return { code: 500, msg: error.message || '网络错误，请稍后重试' }
      }
    },
    async sendSmsCode() {
      if (!this.username.trim() || !this.password) {
        this.errors.username = !this.username.trim() ? '请填写用户账号' : ''
        this.errors.password = !this.password ? '请填写登录密码' : ''
        return
      }

      this.isSending = true

      try {
        // 先校验账号密码
        const validateResult = await this.validateCredentials()
        if (validateResult.code !== 200) {
          this.showNotification(validateResult.msg, 'error')
          this.isSending = false
          return
        }
        // 使用后端返回的手机号发送短信验证码
        const data = await api.sendSmsCode(this.username)
        if (data.code === 200) {
          this.uuid = data.uuid
          this.showNotification('短信验证码已发送到您的手机', 'success')

          // 倒计时
          let timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(timer)
              this.isSending = false
              this.countdown = 60
            }
          }, 1000)
        } else {
          this.showNotification(data.msg, 'error')
          this.isSending = false
        }
      } catch (error) {
        console.error('发送短信验证码失败:', error)
        this.showNotification(error.message || '网络错误，请稍后重试', 'error')
        this.isSending = false
      }
    },
    async handleLogin() {
      if (!this.validateForm()) {
        return
      }

      this.loading = true

      try {
        let data
        if (this.isEnterpriseUser) {
          if (!this.uuid) {
            this.showNotification('请先发送短信验证码', 'error')
            this.loading = false
            return
          }
          data = await api.login(this.username, this.password, this.code, this.uuid, this.originalPhone)
        } else {
          data = await api.login(this.username, this.password, '', '', '')
        }

        if (data.code === 200) {
          // 存储token
          localStorage.setItem('token', data.token)

          Cookies.set(this.TokenKey, data.token)
          // 显示登录成功提示
          this.showSuccessMessage = true
          // 0.5秒后淡出并跳转
          setTimeout(() => {
            this.showSuccessMessage = false
            // 再延迟一点时间跳转，确保动画完成
            setTimeout(() => {
                window.open(CURRENT_CONFIG.CONSOLE_URL , '_blank');
              this.$router.push('/')
            }, 100)
          }, 500)
        } else {
          this.showNotification(data.msg, 'error')
        }
      } catch (error) {
        console.error('登录失败:', error)
        this.showNotification(error)
      } finally {
        this.loading = false
      }
    },
    handleJoinAssociation() {
      this.showNotification('将跳转到入会申请页面')
    },
    showNotification(message, type = 'info') {
      this.notification = {
        show: true,
        message,
        type
      }
      setTimeout(() => {
        this.hideNotification()
      }, 2000)
    },
    hideNotification() {
      this.notification.show = false
    },

    async checkUserRole() {
      if (!this.username.trim()) {
        return
      }

      this.checkingRole = true
      try {
        const data = await api.getUserRole(this.username)
        if (data.code === 500) {
            this.showNotification(data.msg, 'error')
            return
        }
        this.isEnterpriseUser = data.msg === '企业用户' || !data.msg
          // 校验通过后获取手机号并展示脱敏手机号
        if (data.msg === '企业用户' && data.mobile) {
          // 保存原始手机号用于发送验证码
          this.originalPhone = data.mobile
          // 展示脱敏手机号
          this.phone = data.mobile
        } else if (data.msg === '企业用户' && !data.mobile) {
          this.showNotification('获取手机号失败，请联系管理员', 'error')
          this.isSending = false
          return
       } else {
            this.isSending = false
            return
       }
      } catch (error) {
        console.error('检查用户角色失败:', error)
        // 出错时默认视为企业用户，保持原有流程
        this.isEnterpriseUser = true
      } finally {
        this.checkingRole = false
      }
    }
  },
  mounted() {
    // 初始化操作
  }
}
</script>

<style scoped>
.login-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #374151;
  background-color: #f8fafc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.login-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.login-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #4B60E7;
}

.login-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1);
}

.input-container {
  position: relative;
  margin-bottom: 24px;
}

.input-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 16px;
  transition: all 0.3s ease;
  z-index: 2;
}

.form-input {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px 12px 48px;
  font-size: 14px;
  transition: all 0.3s ease;
  width: 100%;
  background-color: white;
}

.form-input:focus {
  outline: none;
  border-color: #4B60E7;
  box-shadow: 0 0 0 3px rgba(75, 96, 231, 0.1);
}

.form-input:focus + .input-icon,
.input-container:focus-within .input-icon {
  color: #667eea;
  transform: translateY(-50%) scale(1.1);
}

.form-input:hover {
  border-color: #4B60E7;
}

.btn-primary {
  background-color: #4B60E7;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  display: inline-block;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(75, 96, 231, 0.2);
  width: 100%;
}

.btn-primary:hover {
  background-color: #3A4FB8;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(75, 96, 231, 0.3);
}

.captcha-container {
  display: flex;
  gap: 12px;
}

.captcha-image {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: #4B60E7;
  transition: all 0.3s ease;
  user-select: none;
  border: 1px solid #e2e8f0;
  min-width: 100px;
}

.captcha-image:hover {
  background-color: #e2e8f0;
  border-color: #4B60E7;
}

.btn-sms {
  font-size: 12px;
  white-space: nowrap;
  min-width: 100px;
}

.error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
}



@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out forwards;
}

@media (max-width: 768px) {
  .login-card {
    margin: 0 16px;
    padding: 32px 24px;
  }

  .form-input {
    padding: 14px 18px 14px 48px;
    font-size: 16px;
  }

  .captcha-image {
    min-width: 100px;
    padding: 14px 16px;
  }

  .input-icon {
    left: 16px;
  }

  .btn-primary {
    padding: 14px 20px;
    font-size: 16px;
  }

  .form-input,
  .btn-primary,
  .captcha-image {
    -webkit-tap-highlight-color: transparent;
    min-height: 44px;
  }
}

@media (max-width: 480px) {
  .login-card {
    margin: 0 12px;
    padding: 24px 20px;
  }

  .input-container {
    margin-bottom: 20px;
  }

  .captcha-container {
    gap: 12px;
  }

  .captcha-image {
    min-width: 80px;
    padding: 12px 8px;
  }
}

/* 登录成功提示样式 */
.success-message {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-out;
}

.success-message[style*="display: none"] {
  opacity: 0;
}

.success-content {
  background-color: white;
  padding: 20px 40px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #4B60E7;
  box-shadow: 0 4px 12px rgba(75, 96, 231, 0.2);
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 通知组件样式 */
.notification {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px 24px;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 1;
  transition: opacity 0.5s ease-out;
}

.notification[style*="display: none"] {
  opacity: 0;
}

.notification.info {
  background-color: #4B60E7;
}

.notification.success {
  background-color: #10B981;
}

.notification.error {
  background-color: #EF4444;
}
</style>
